import axios from 'axios';
import store from '../store';

function uploadRouteFile (data, routeId) {
  let currentClientId = store.state.client.currentClient.id;
  let formData = new FormData();
  formData.append('image', data);
  formData.append('currentClientId', currentClientId);
  formData.append('route_id', routeId);
  return axios.post('api/client/' + currentClientId + '/uploadRouteImage', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

function saveTour (tour) {
  axios.post('api/client/' + tour.clientId + '/saveTour', {
    id: tour.id,
    card: tour.card,
    city: tour.city,
    clientId: tour.clientId,
    defaultActivate: tour.defaultActivate,
    defaultDelay: tour.defaultDelay,
    defaultRadiusDistance: tour.defaultRadiusDistance,
    defaultTolerance: tour.defaultTolerance,
    description: tour.description,
    name: tour.name,
    systemId: tour.systemId,
    latLng: tour.latLng,
    timezone_id: tour.timezone_id
  })
    .catch(function (error) {
      console.log(error);
    });
}

function saveTours (tour) {
  axios.post('api/client/' + tour.clientId + '/saveTours', {
    id: tour.id,
    card: tour.card,
    city: tour.city,
    clientId: tour.clientId,
    description: tour.description,
    name: tour.name,
    systemId: tour.systemId,
    latLng: tour.latLng,
    timezone_id: tour.timezone_id
  })
    .catch(function (error) {
      console.log(error);
    });
}

function getRouteTopics (routeId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/getRouteTopics/' + routeId);
}

function updateRouteDetails (route) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/saveRoute', {
    id: route.id,
    clientId: route.clientId,
    systemId: route.systemId,
    notificationSound: route.notificationSound,
    notificationSongId: route.notificationSongId,
    name: route.name,
    description: route.description,
    vehicleId: route.vehicleId,
    path: JSON.stringify(route.path),
    alt_path: JSON.stringify(route.alt_path),
    channels: route.channels,
    commentary: route.commentary,
    commentaryDelay: route.commentaryDelay,
    audioControllerNotification: route.audioControllerNotification,
    audioControllerFlashTime: route.audioControllerFlashTime,
    headendSys: route.headendSys
  });
}

function updateRouteTopics (topicOrder) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/updateRouteTopicOrder', {topicOrder: topicOrder});
}

function newTour (tour) {
  let formData = new FormData();
  formData.append('image', tour.image);
  formData.append('card', tour.card);
  formData.append('city', tour.city);
  formData.append('clientId', tour.clientId);
  formData.append('defaultActivate', tour.defaultActivate);
  formData.append('defaultDelay', tour.defaultDelay);
  formData.append('defaultRadiusDistance', tour.defaultRadiusDistance);
  formData.append('defaultTolerance', tour.defaultTolerance);
  formData.append('description', tour.description);
  formData.append('name', tour.name);
  formData.append('systemId', tour.systemId);
  formData.append('latLng', JSON.stringify(tour.latLng));
  return axios.post('api/client/' + tour.clientId + '/newTour',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
}

function newTopic (topic) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/newTopic', {
    avatar: topic.avatar,
    icon: topic.icon,
    placeId: topic.place_id,
    city: topic.city,
    tourId: store.state.tours.currentTour.id,
    reference: topic.reference,
    viewport: topic.viewport,
    address: topic.formatted_address,
    name: topic.name,
    idInPlace: topic.id,
    isReal: topic.isReal,
    latLng: JSON.stringify(topic.latLng)
  });
}

function updateTopics () {
  let currentClientId = store.state.client.currentClient.id;
  axios.post('api/client/' + currentClientId + '/updateTopics', {
    topics: store.state.topics.topicsList
  })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch('topics/toggleVirtualConditional', false);
        return response;
      }
    }).catch(function (error) {
      console.log(error);
    });
}

function getTopicTriggers (routeId, topicId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/getTopicTriggers/' + routeId + '/' + topicId);
}

function saveNewRoute (newRoute) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/insertNewRoute', newRoute);
}

function addNewRouteTopics (payload) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/insertNewRouteTopics', payload);
}

function saveTrigger (trigger) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('apiclient/' + currentClientId + '/updateTrigger', trigger);
}

function updateTriggerName (trigger) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('apiclient/' + currentClientId + '/updateTriggerName', trigger);
}

function saveTopic (topic) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/updateTopics', {topics: topic});
}

function addTrigger (trigger) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/insertTrigger', trigger);
}

function deleteTopicFromRoute (ids) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/routes/' + ids[0] + '/topics/remove', {
    routeID: ids[0],
    topicIDs: ids[1]
  });
}

function checkExportTours (tourId) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.get('api/client/' + currentClientId + '/checkExportTours/' + tourId);
}

export {
  saveTour,
  saveTours,
  newTopic,
  getRouteTopics,
  updateRouteDetails,
  newTour,
  updateRouteTopics,
  saveNewRoute,
  getTopicTriggers,
  saveTrigger,
  saveTopic,
  addTrigger,
  updateTopics,
  addNewRouteTopics,
  deleteTopicFromRoute,
  updateTriggerName,
  checkExportTours,
  uploadRouteFile
};



// WEBPACK FOOTER //
// ./src/services/EditorService.js